import LinkCell from "./LinkCell";
import LinkReel from "./LinkReel";
export default class LinkReelRotation extends LinkReel {
    constructor(x, y, index, orientation, linkCellCreation) {
        super(x, y, index, orientation, linkCellCreation);
        for (let i = 0; i < 1; i++) {
            this.linkCells[i] = new LinkCell(this.linkCellsPosition[1].x, this.linkCellsPosition[1].y, i, index);
            this.getContainer().add(this.linkCells[i].getContainer());
        }
    }
    configureSpinTween() {
        this.resetFlagsAndCounters();
        this.spinProgress = scene.tweens.add({
            targets: this.spinProgressValue,
            ease: "Linear",
            value: { from: 0, to: 1 }, // non serve spostare niente, è un timer
            paused: true,
            loop: 0, // una sola animazione
            yoyo: false,
            duration: 2200, // DURATA TOTALE dello spin (es. 3 secondi)
            onStart: () => {
                // Avvia la rotazione della moneta in TUTTE le celle
                this.linkCells.forEach(linkCell => {
                    linkCell.stopAnimation();
                    linkCell.startCoinSpin();
                });
                this.stopped = false;
                this.canStop = false;
                // ========== TWEEN DI DECELERAZIONE (ease-out) ==========
                // Questo tween farà rallentare progressivamente la moneta negli ultimi 800ms
                scene.tweens.add({
                    targets: this.linkCells.map(cell => ({
                        cell: cell,
                        timeScale: 2 // valore iniziale
                    })),
                    ease: "Cubic.Out", // decelerazione naturale
                    timeScale: 0.2, // valore finale (quasi fermo)
                    duration: 300, // ultimi 800ms prima dello stop
                    delay: 2200 - 300, // parte dopo 2200ms (quando mancano 800ms)
                    onUpdate: (tween) => {
                        if (this.stopped)
                            return;
                        const progress = tween.progress;
                        const currentTimeScale = 2 - (progress * 1.9);
                        this.linkCells.forEach(linkCell => {
                            const spine = linkCell.getSpine(linkCell.getMemo());
                            if (spine?.animationState.tracks[0]) {
                                spine.animationState.tracks[0].timeScale = currentTimeScale;
                            }
                        });
                    }
                });
            },
            onComplete: () => {
                // Qui avviene lo stop delle monete
                if (!this.stopped) {
                    this.stopCoinAnimations();
                }
                // callback del reel completato
                scene.linkSpinGameArea.notifySpinCompleted(this.index);
                // stop bottone spin
                if (this.spinMainButtonTween && this.spinMainButtonTween.isPlaying()) {
                    this.spinMainButtonTween.stop();
                    window.isButtonSpinning = false;
                }
            }
        });
    }
    // This check is done for safety. It should NEVER happen that the reels are still spinning when this method is called.
    securityCheckStop() {
        if (this.spinProgress?.isPlaying()) {
            this.spinProgress.stop();
        }
        else if (this.bounceTween1?.isPlaying()) {
            this.bounceTween1.stop();
        }
        else if (this.bounceTween2?.isPlaying()) {
            this.bounceTween2.stop();
        }
    }
    stopCoinAnimations() {
        this.stopped = true;
        this.linkCells.forEach(linkCell => {
            linkCell.stopCoinSpin();
        });
    }
}
